import type { ScreenKey } from './model/types';

/** React Query keys for screen access. `mine` is shared by the menu and the screen itself. */
export const screenAccessQueryKeys = {
  all: ['screen-access'] as const,
  mine: (screen: ScreenKey, companyRefId: number) => [...screenAccessQueryKeys.all, 'mine', screen, companyRefId] as const,
  matrix: (screen: ScreenKey, companyRefId: number) => [...screenAccessQueryKeys.all, 'matrix', screen, companyRefId] as const,
};
